import React from 'react';
import Layout from '../layouts/Layout'
import validator from "../services/validation"
import ipdata from "../services/ipdata"
import mailer from "../services/mail"
import { NextSeo } from 'next-seo';
import { FaFacebookF } from '@react-icons/all-files/fa/FaFacebookF'
import { FaTwitter } from '@react-icons/all-files/fa/FaTwitter'
import { FaLinkedinIn } from '@react-icons/all-files/fa/FaLinkedinIn'
import { MdEmail } from '@react-icons/all-files/md/MdEmail';
import { MdArrowForward } from '@react-icons/all-files/md/MdArrowForward';
import { MdLocationOn } from "@react-icons/all-files/md/MdLocationOn";
import SlackWebHook from "../services/slack";
import { post } from "../services/fetch"
import { error, success } from "../components/Toast";

const AddressList = [
    {
      "TYPE": "Kolkata",
      "ADDRESS_1": "97 Park Street",
      "ADDRESS_2": "3rd Floor",
      "CITY": "Kolkata",
      "STATE": "",
      "COUNTRY": "",
      "PINCODE": "700016",
      "MOBILE": "085-848-76892",
      "EMAIL": ""
    },
    {
      "TYPE": "Gurgaon",
      "ADDRESS_1": "1220, Ground Floor, DLF Phase IV",
      "ADDRESS_2": "Opposite Galleria Market",
      "CITY": "Gurgaon (Haryana)",
      "STATE": "",
      "COUNTRY": "",
      "PINCODE": "122009",
      "MOBILE": "085-058-31919",
      "EMAIL": ""
    },
    {
      "TYPE": "Connaught Place",
      "ADDRESS_1": "8 C Vandana building",
      "ADDRESS_2": "11, Atul Grove Road, Janpath",
      "CITY": "New Delhi",
      "STATE": "Delhi",
      "COUNTRY": "",
      "PINCODE": "110001",
      "MOBILE": "085-058-31919",
      "EMAIL": ""
    }
  ]

class Contact extends React.Component {

    state = {
        name: "",
        email: "",
        mobile: "",
        location: "",
        description: "",
        validator: false,
        disabled: false,
        locationDetails: ''
    }

    componentDidMount() {
        ipdata.getLocation().then((res) => {
            if(res) {
                this.setState({locationDetails: JSON.parse(localStorage.getItem('user_location_details_local')).geoLocationDetails});
            }
        }).catch((err) => {
            console.log(err);
        });
    }

    onChange = (e) => {
        const state = this.state;
        state[e.target.name] = e.target.value;
        state.validator = false;
        this.setState(state);
    }

    onSubmit = () => {
        const parentThis = this;
        const state = parentThis.state;
        state.name = state.name.trim();
        state.description = state.description.trim();
        let flag = false;
        if( validator.text(state.name)
            && validator.email(state.email)
            && validator.text(state.description)
        ){
            if(state.locationDetails.country_code === 'IN'){
                flag = validator.mobile(state.mobile);
            }
            else{
                flag = true
            }
        }

        if(flag) {
            state.disabled = true;
            parentThis.setState(state);
            let mobile = state.mobile !== ''? `+${state.locationDetails.calling_code} ${state.mobile}`:'';
            let input = {
                name: state.name,
                email: state.email,
                mobile: mobile,
                location: state.location,
                description: state.description,
                contactType: 'contact_us'
            };
            post(`${process.env.NEXT_PUBLIC_API_URI}${process.env.NEXT_PUBLIC_API_VERSION}/contactUs?_format=json`, input, {}).then((res) => {
                if(res.code === "201" && res.status === "success") {
                    let data = {
                        fullName: state.name
                    }
                    mailer.sendMail(state.email, "contactUs-mail", [], [], "You have sent a request.", false, data).then((res) => {
                        if(res.status === 'success' && res.code === '250'){
                            console.log("mail-sent");
                        }
                    }).catch((err) => {
                        console.log(err);
                    });
                    try{
                        SlackWebHook.sendSlackMessage(`New contact request from ${input.name} (${input.email} - ${input.mobile}) from ${input.location}`, 'Contact Us', ':computer');
                    }
                    catch (e) {
                        console.log(e);
                    }
                    let adminData = {
                        fullName: state.name,
                        mail: state.email,
                        phone: mobile,
                        location: state.location,
                        message: state.description
                    }
                    mailer.sendMail(process.env.NEXT_PUBLIC_ADMIN_EMAIL, "contactUsAdmin-mail", [], [], "New Contact Request", false, adminData).then((res) => {
                        if(res.status === 'success' && res.code === '250'){
                            console.log("mail-sent-admin");
                        }
                    }).catch((err) => {
                        console.log(err);
                    });
                    state.name = "";
                    state.email = "";
                    state.mobile = "";
                    state.location = "";
                    state.description = "";
                    state.disabled = false;
                    parentThis.setState(state);
                    success('Thank you for contacting with us.');
                }else{
                    state.disabled = false;
                    parentThis.setState(state);
                    error('Something went wrong!');
                }
            }).catch(() => {
                state.disabled = false;
                parentThis.setState(state);
                error('Something went wrong!');
            });
        }
        else{
            state.validator = true;
            parentThis.setState(state);
        }
    }

    render() {
        return(
            <Layout>
                {
                    process.env.NEXT_PUBLIC_ENV === 'production' &&
                    <NextSeo
                        title='Contact Us'
                        titleTemplate='Collegify | %s'
                        copyright='Collegify has copyrights to all the content on the page.'
                        keywords='kolkata,delhi,gurgaon,hong kong,italy,switzerland,abroad studies,contact us,reach us,happy to help,24x7 support,feedback,consulting enquiry,'
                        description='Talk to us at Collegify. We’re always happy to help, either on call, mail or social media!'
                        openGraph={{
                            url: process.env.NEXT_PUBLIC_APP_URI + "/contact",
                            title: 'Collegify | Contact Us',
                            type: 'website',
                            locale: 'en_US',
                            description: 'Talk to us at Collegify. We’re always happy to help, either on call, mail or social media!',
                            images: [
                                {
                                    url: process.env.NEXT_PUBLIC_FILE_URI + 'social-banner/contact.jpg',
                                    width: 500,
                                    height: 500,
                                    alt: 'Interactive Platform for Adaptive Learning',
                                },
                            ],
                            site_name: 'Collegify',
                        }}
                    />
                }
                <div id="contact">
                    {/* Contact Intro Section */}
                    <section className="contact-intro-section nav-margin">
                        <div className="container">
                            <div className="row py-5">
                                <div className="col-md-5">
                                    <h1 className="mb-3">Talk to us at Collegify.</h1>
                                    <p>We’re always happy to help, either on call, mail or social media!</p>
                                </div>
                            </div>
                        </div>
                    </section>

                    {/* Contact Details Card */}
                    <section className="container">
                        <div className="card contact-card mb-4">
                            <div className="card-body">
                                <div className="d-flex gap justify-content-center align-items-center flex-wrap">
                                    <MdEmail className="text-secondary" fontSize="28px" />
                                    <h3 className="text-center fw-bolder mb-0">
                                        info@collegify.com
                                    </h3>
                                </div>
                            </div>
                        </div>
                        <div className="contact--social-icons flex-row gap justify-content-center">
                            <a href="https://www.facebook.com/collegify" target="_blank">
                                <div className="footer-social-circle"><FaFacebookF /></div>
                            </a>
                            <a href="https://www.twitter.com/collegify" target="_blank">
                                <div className="footer-social-circle"><FaTwitter /></div>
                            </a>
                            <a href="https://www.linkedin.com/company/2692554/" target="_blank">
                                <div className="footer-social-circle"><FaLinkedinIn /></div>
                            </a>
                        </div>
                    </section>

                    {/* Office Addresses */}
                    <section className='pt-5'>
                        <div className='container'>
                            {/* <h4 className='text-center mb-5'>Visit us at any of our branches in India</h4> */}

                            <div className='row justify-content-center'>
                                {
                                    AddressList.map((address, key) => (
                                        <div className='col-md-5 offset-md-1 mb-5' key={key}>
                                            <div className='d-flex jsutify-content-start align-items-center mb-2 '>
                                                <MdLocationOn fontSize="20px" className="text-secondary me-2" />
                                                <h4 className='fw-bold mb-0'>{address.TYPE}</h4>
                                            </div>
                                            <div className='ms-4'>
                                                <h5 className='font-weight-light mb-2'>
                                                    {address.ADDRESS_1}
                                                    <br />
                                                    {address.ADDRESS_2}{
                                                        address.CITY && address.PINCODE &&
                                                    <><br /> {address.CITY} - {address.PINCODE}</>}
                                                </h5>
                                                <div className='d-flex jsutify-content-start align-items-center'>
                                                    <svg width="51" height="51" viewBox="0 0 51 51" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ width: 20 }} className="me-2">
                                                        <path fillRule="evenodd" clipRule="evenodd" d="M12.3787 38.0775C4.66867 30.3674 0.694754 20.3477 0.423033 10.2601C0.423031 9.64869 0.660786 9.03731 1.11931 8.57879C1.59483 8.10327 2.2062 7.86552 2.81757 7.86552L11.2409 7.86552C11.8523 7.86552 12.4637 8.10327 12.9392 8.57878C13.3977 9.03731 13.6524 9.63171 13.6524 10.2431C13.7543 12.8244 14.1959 15.4058 15.028 17.9022C15.3167 18.7344 15.1129 19.7193 14.4506 20.3817L9.18603 25.6463C10.8503 28.9069 13.058 31.9638 15.7753 34.681C18.4925 37.3982 21.5493 39.6059 24.827 41.2532L30.0916 35.9886C30.7709 35.3093 31.7389 35.1225 32.571 35.4112C35.0505 36.2264 37.6318 36.7019 40.2301 36.7868C40.8245 36.8038 41.4359 37.0415 41.8944 37.5001C42.3699 37.9756 42.6077 38.587 42.6077 39.1983L42.6077 47.6217C42.6077 48.233 42.3699 48.8444 41.8944 49.3199C41.4189 49.7954 40.8075 50.0332 40.1962 50.0332C30.1085 49.7615 20.0888 45.7876 12.3787 38.0775ZM37.8017 41.4229C36.0185 41.2361 34.2184 40.8965 32.4692 40.404L32.4522 40.387L29.5652 43.274C32.2144 44.1911 34.9826 44.7855 37.8017 45.0572V41.4229ZM9.01646 12.6716C9.20327 14.4888 9.54292 16.255 10.0354 18.0042L7.14838 20.8912C6.24831 18.2589 5.65392 15.4907 5.3822 12.6716L9.01646 12.6716ZM24.6299 0.611118H19.8409C19.9767 0.848873 19.8578 12.6857 19.8578 12.6857H24.6469L24.6299 0.611118ZM44.3301 10.6318L40.9336 7.23527L32.4423 15.7265L35.8389 19.1231L44.3301 10.6318ZM38.8785 26.9172V31.7063C38.8785 31.7063 50.7153 31.5874 50.9531 31.7233L50.9531 26.9002L38.8785 26.9172Z" fill="#ffd000" />
                                                    </svg>
                                                    {/* <MdRingVol style={{ width: 20 }} className="me-2" /> */}
                                                    <h5 className='mb-0'>
                                                        <a href={`tel:${address.MOBILE}`} className='d-md-none'>
                                                            {address.MOBILE}
                                                        </a>
                                                        <span className='d-none d-md-block'>{address.MOBILE}</span>
                                                    </h5>
                                                </div>
                                            </div>
                                        </div>
                                    ))
                                }
                            </div>
                        </div>
                    </section>

                    {/* Contact Form */}
                    <section className="py-2">
                        <div className="container">
                            <h4 className="fw-600 text-center mb-5"> or leave a message below and we’ll get back to you.</h4>
                            <div className="contact-form mb-5">
                                <form className="row g-3" onSubmit={(e) => e.preventDefault()} id="contact-us">
                                    <div className="form-group col-lg-6">
                                        <label htmlFor="name">Name</label>
                                        <input type="text" className={`form-control ${this.state.validator && (validator.text(this.state.name) ? "is-valid" : "is-invalid")}`} name="name" id="name" autoComplete="name" value={this.state.name} onChange={this.onChange.bind(this)} />
                                    </div>
                                    <div className="form-group col-lg-6">
                                        <label htmlFor="email">Email</label>
                                        <input type="email" className={`form-control ${this.state.validator && (validator.email(this.state.email) ? "is-valid" : "is-invalid")}`} name="email" id="email" autoComplete="email" value={this.state.email} onChange={this.onChange.bind(this)} />
                                    </div>
                                    <div className="form-group col-lg-6">
                                        <label htmlFor="mobile">Phone Number{ this.state.locationDetails.country_code !== 'IN' && ' (Optional)'}</label>
                                        <input type="tel" className={`form-control ${this.state.locationDetails.country_code === 'IN' && this.state.validator && (validator.mobile(this.state.mobile) ? "is-valid" : "is-invalid")}`} name="mobile" id="mobile" autoComplete="tel" value={this.state.mobile} onChange={this.onChange.bind(this)} />
                                    </div>
                                    <div className="form-group col-lg-6">
                                        <label htmlFor="location">Location (Optional)</label>
                                        <input type="text" className={`form-control`} name="location" id="location"
                                            autoComplete="address-level1" value={this.state.location} onChange={this.onChange.bind(this)} />
                                    </div>
                                    <div className="form-floating mb-3">
                                        <textarea className={`form-control ${this.state.validator && (validator.text(this.state.description) ? "is-valid" : "is-invalid")}`} value={this.state.description} onChange={this.onChange.bind(this)}
                                            placeholder="Tell us something you want to know, or let us know what you like (or don’t like) about Collegify" id="description" name="description" style={{height: '160px'}}></textarea>
                                        <label htmlFor="description">Message</label>
                                    </div>
                                    <div className="flex-row justify-content-end">
                                        <button
                                            id="sendMail"
                                            className="btn btn-secondary bg-white btn-with-icon"
                                            disabled={this.state.disabled} onClick={this.onSubmit.bind(this)}
                                        >
                                            Send Message
                                            <span className="btn-icon bg-yellow"><MdArrowForward className="material-icons" /></span>
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </section>

                    {/* <FreeTrialCTA /> */}

                </div>
            </Layout>
        )
    }
}

export default Contact
